import { useEffect, useState } from 'react';

type Listener = () => void;
const listeners = new Set<Listener>();

export function currentPath(): string {
  const h = window.location.hash.replace(/^#/, '');
  return h === '' ? '/' : h;
}

/** Go to a page of the app. replace=true does not add a browser-history entry (used for page turning). */
export function navigate(path: string, replace = false): void {
  const url = '#' + path;
  if (replace) window.history.replaceState(null, '', url);
  else window.history.pushState(null, '', url);
  listeners.forEach((l) => l());
}

export function useRoute(): string {
  const [path, setPath] = useState(currentPath());
  useEffect(() => {
    const sync = () => setPath(currentPath());
    listeners.add(sync);
    window.addEventListener('popstate', sync);
    window.addEventListener('hashchange', sync);
    return () => {
      listeners.delete(sync);
      window.removeEventListener('popstate', sync);
      window.removeEventListener('hashchange', sync);
    };
  }, []);
  return path;
}
